// extracted by mini-css-extract-plugin
export default {"cell":"OperatorSelectCell_cell__revRG"};